import React from 'react'
import PanelMemberTemplate from '../../components/PanelMemberTemplate'
import { Chan_data } from '../../assets'

const WillieSaiHoChan = () => {
  return (
    <>
    <PanelMemberTemplate {...Chan_data}/>
    </>
  )
}

export default WillieSaiHoChan
